export default "__VITE_ASSET__CRJ4bzIl__"